// Footer menu toggle functionality
document.addEventListener('DOMContentLoaded', function() {
  // Get all footer toggle buttons
  const toggleButtons = document.querySelectorAll('.js-footer-toggle');
  const iconStrokeWidth = window.themeSettings?.icon_stroke_width || 1.5;
  
  // Add CSS for smooth transitions
  const style = document.createElement('style');
  style.textContent = `
    /* 调整菜单项为上下结构布局 */
    .footer__item-list {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    /* 确保箭头图标在容器最右侧 */
    .js-footer-toggle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      text-align: left;
      padding: 0;
      background: none;
      border: none;
      cursor: pointer;
    }
    
    @media (min-width: 769px) {
      .footer__item-list {
        flex-direction: row;
        flex-wrap: wrap;
      }
    }
    
    .footer__item-content--collapsible {
      overflow: hidden;
      transition: all 0.3s ease;
    }
    
    .footer__item-content--collapsed {
      max-height: 0;
      opacity: 0;
      margin-top: 0;
      margin-bottom: 0;
    }
    
    .footer__toggle-icon {
      display: inline-block;
      transition: transform 0.3s ease;
      margin-left: 1px;
      vertical-align: middle;
    }
    
    .footer__toggle-icon--rotated {
      transform: rotate(180deg);
    }
    
    @media (min-width: 769px) {
      .js-footer-toggle .footer__toggle-icon {
        display: none;
      }
      
      .footer__item-content--collapsible {
        max-height: none !important;
        opacity: 1 !important;
      }
    }
  `;
  document.head.appendChild(style);
  
  // Add event listener to each toggle button
  toggleButtons.forEach(button => {
    // Get the target element ID from data attribute
    const targetId = button.getAttribute('data-target');
    const targetElement = document.getElementById(targetId);
    const toggleIcon = button.querySelector('.footer__toggle-icon');
    
    // Set initial state - collapsed by default for mobile
    if (targetElement && window.innerWidth < 769) {
      targetElement.style.maxHeight = '0';
      
      // Update ARIA attributes for screen readers
      button.setAttribute('aria-expanded', 'false');
      targetElement.setAttribute('aria-hidden', 'true');
    }
    
    button.addEventListener('click', function() {
      if (targetElement && window.innerWidth < 769) {
        // Toggle visibility of the target element
        const isExpanded = !targetElement.classList.contains('footer__item-content--collapsed');
        
        if (isExpanded) {
          // Collapse the menu
          targetElement.classList.add('footer__item-content--collapsed');
          targetElement.style.maxHeight = '0';
          if (toggleIcon) {
            toggleIcon.classList.remove('footer__toggle-icon--rotated');
          }
          
          // Update ARIA attributes for screen readers
          button.setAttribute('aria-expanded', 'false');
          targetElement.setAttribute('aria-hidden', 'true');
        } else {
          // Expand the menu
          targetElement.classList.remove('footer__item-content--collapsed');
          targetElement.style.maxHeight = targetElement.scrollHeight + 'px';
          if (toggleIcon) {
            toggleIcon.classList.add('footer__toggle-icon--rotated');
          }
          
          // Update ARIA attributes for screen readers
          button.setAttribute('aria-expanded', 'true');
          targetElement.setAttribute('aria-hidden', 'false');
        }
      }
    });
  });
});